"use strict";

import React from 'react';
import SvgExpandIcon from "../../component/SvgExpandIcon";

const ProductGalleryToolbar = ({className='', style={}, index=0, slidesLength=0, iconSize=48, onFullScreenClick=()=>{},}) => {
    return (
        <div className={`product-detail__slides__toolbar__container ${className}`} style={style}>
            <p className="product-detail__slides__toolbar__current-slide">{index + 1} / {slidesLength}</p>
            <a href="#" title="Full Screen" onClick={onFullScreenClick}
               className="product-detail__slides__toolbar__action-link"
               style={{lineHeight: '0',}}>
                <SvgExpandIcon className="product-detail__slides__toolbar__action-link__icon" size={iconSize} />
            </a>
        </div>
    );
};

export default ProductGalleryToolbar;
